export default {
  name: 'logout',
  components: {},
  props: [
    'onLogout',
    'authUser',
    'access_token',
  ],
  mounted() {
  },
  data() {
    return {
    };
  },
  methods: {
    getSamlLogoutUrl(upn, providers) {
      if (upn.indexOf('@') > -1) {
        const userSuffix = upn.split('@')[1];
        for (let i = 0; i < providers.length; i++) {
          for (let ii = 0; ii < providers[i].suffixes.length; ii++) {
            if (userSuffix === providers[i].suffixes[ii]) {
              return providers[i].logout_url;
            }
          }
        }
      }
    },
    samlLogout() {
      const providers = localStorage.getItem('samlProviders');
      this.samlProviders = providers ? JSON.parse(providers) : null;
      console.log(this.authUser);
      if (this.samlProviders && this.authUser.upn) {
        const logoutUrl = this.getSamlLogoutUrl(this.authUser.upn, this.samlProviders);
        window.open(logoutUrl, '_blank');
      }
    }
  },
  computed: {

  },
  created() {
    this.samlLogout();
    this.$emit('logout');
    //localStorage.clear();
    //sessionStorage.clear();
    //document.cookie.split(";").forEach(function (c) { document.cookie = c.replace(/^ +/, "").replace(/=.*/, "=;expires=" + new Date().toUTCString() + ";path=/"); });
    localStorage.setItem("remove_access_token", true);
    localStorage.setItem("remove_authUser", true);

    if (this.$route.query.logoutPortal) {
      window.location.href = process.env.PORTAL_URL + "/logout";
    } else {
      this.$router.push({ name: 'login' });
    }
  },
};



// WEBPACK FOOTER //
// ./src/components/logout/logout.component.js